const url = new URL(window.location);
const { searchParams,pathname } = url;
const activationToken = searchParams.get('token');

if (activationToken) {
  // Collect and store locally
  sessionStorage.setItem('activationToken', activationToken);

  // Clean up the URL
  searchParams.delete('token');
  // Put back the clean URL
  window.history.replaceState({}, '', url);
} 